import { AuthService } from './../../shared/models/auth.service';
import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';

@Injectable()
export class DriverAdminService {
  constructor(private authService: AuthService, private http: Http) { }

  public GetCurrentDriverDetail(): Observable<IAPIResponse> {
    let getDriverUrl = WeGoConfig.API_GET_CURRENT_DRIVER;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getDriverUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetCurrentDriverDetailByDriverId(driverHashId: string): Observable<IAPIResponse> {
    let getDriverUrl = WeGoConfig.API_GET_SELECTED_DRIVER;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    getDriverUrl =
    getDriverUrl +
      '?driverHashId=' +
      driverHashId;
    return this.http.get(getDriverUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }  
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/driveradmin/models/driveradmin.service.ts